export default function ContactSection() {
  const categories = [
    'iOS Engineering',
    'System Architecture',
    'Performance',
    'Quality Assurance',
  ];

  const bottomLabelsLeft = ['Engineering', 'Design'];
  const bottomLabelsRight = ['iOS', 'Quality'];

  return (
    <footer className="w-full px-6 md:px-10 py-10 md:py-14">
      <div className="max-w-6xl mx-auto bg-foreground-950 rounded-lg px-8 md:px-14 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 mb-16 md:mb-20">
          <div className="md:col-span-5">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white font-heading mb-4">
              Get in touch
            </h2>
            <p className="text-sm md:text-base text-white/50 leading-relaxed max-w-sm mb-10">
              We are based in Sweden and work with clients across Europe,
              delivering engineering solutions grounded in quality and reliability.
            </p>
            <address className="not-italic text-sm md:text-base text-white/70 leading-relaxed space-y-1">
              <p>Gullrisgatan 25</p>
              <p>692 71 Kumla</p>
              <p>Sweden</p>
            </address>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs md:text-sm font-semibold text-white/40 uppercase tracking-widest mb-5">
              Expertise
            </h3>
            <nav>
              <ul className="space-y-3">
                {categories.map((cat) => (
                  <li key={cat}>
                    <span className="text-sm md:text-base text-white/50 underline decoration-white/20 underline-offset-4">
                      {cat}
                    </span>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-xs md:text-sm font-semibold text-white/40 uppercase tracking-widest mb-5">
              Direct Contact
            </h3>
            <div className="space-y-3 mb-10">
              <p className="text-sm md:text-base text-white/70">+46 734730079</p>
              <p className="text-sm md:text-base text-white/70">contact@siavashmedia.com</p>
            </div>

            <h3 className="text-xs md:text-sm font-semibold text-white/40 uppercase tracking-widest mb-5">
              Office
            </h3>
            <address className="not-italic text-sm md:text-base text-white/50 leading-relaxed space-y-1">
              <p>Gullrisgatan 25</p>
              <p>692 71 Kumla, Sweden</p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            {bottomLabelsLeft.map((label) => (
              <span
                key={label}
                className="text-xs text-white/30 underline decoration-white/10 underline-offset-4"
              >
                {label}
              </span>
            ))}
          </div>

          <p className="text-xs text-white/30 text-center">
            &copy; 2026 All rights reserved.
          </p>

          <div className="flex items-center gap-6">
            {bottomLabelsRight.map((label) => (
              <span
                key={label}
                className="text-xs text-white/30 underline decoration-white/10 underline-offset-4"
              >
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}